import { createMuiTheme } from '@material-ui/core/styles';
import teal from '@material-ui/core/colors/teal';
import red from '@material-ui/core/colors/red';



const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#90be4e",
    },
    secondary: {
      main: "#c5c5c5",
    },
  },
  status: {
      danger: {
          main: red,
      }
  },
});

export default theme;